import pic_01 from './Assets/pic_01.webp';
import pic_02 from './Assets/pic_02.webp';
import pic_03 from './Assets/pic_03.webp';
import pic_04 from './Assets/pic_04.webp';
import pic_05 from './Assets/pic_05.webp';
import pic_06 from './Assets/pic_06.webp';
import pic_07 from './Assets/pic_07.webp';
import pic_08 from './Assets/pic_08.webp';
import pic_09 from './Assets/pic_09.webp';
import pic_10 from './Assets/pic_10.webp';

export const ambassador = {
  name: '',
  description: '',
  image: '',
  socialLinks: {
    instagram: 'javascript:void(0)',
    youtube: 'javascript:void(0)',
    twitter: 'javascript:void(0)',
    tiktok: 'javascript:void(0)',
  },
};

export const EpochInfo = {
  title: 'TIKTOKKO',
  period: '2016 - present',
  description: <>
    <p>
      TIKTOKKO is a turning point in digital history, where Gen Z fully entered the online world, marking the shift from millennial dominance to a new global Internet culture. Think 15-second vertical videos, chaotic energy, dancing teens, raw honesty, bizarre memes, and ultra-personalized content.
    </p>
    <p>
      It took over after the INSTAGRAMINISM era, which shattered the polished, picture-perfect influencer lifestyle. The focus moved from carefully curated photo posts and long captions to quick, punchy videos that completely redefined how we interact online.
    </p>
  </>,
};

export const events = [
  {
    year: '2016',
    title: 'How It All Started: Musical.ly',
    content: (
      <>
        <p>
          Musical.ly launched in August 2014 and quickly became the go-to platform for lip-sync videos, reaching 70 million downloads by mid-2016. Users could create 15-second to 1-minute clips, explore a vast music library, and team up with friends using features like "Duet." By June 2016, it had over 90 million users, growing to 200 million by May 2017. We thought only kids and teens would be into this, but we quickly realized how wrong we were!
        </p>
      </>
    ),
    img: pic_01,
    blurhash: '|68p[b9F0g~AIpJD#ktREL4.S$s:%2%1IUbb$*ofD+-oob9axas-Nxnis.IpaxxaIVWY%KniI:bHocRl$%xZIqjFt5NHjYxuV@j[t7IVt7t5RlWCRkaxS4jcxsS4Rj%0R+jYozM{M{xuRkWYxYofWSafjvx[soIUNws.oe',
    picName: 'pic_01',
  },
  {
    year: '2018',
    title: 'We Are in Our TikTok Era',
    content: (
      <>
        <p>
          In a bold move, China's Bytedance acquired Musical.ly for $1 billion and rebranded it as TikTok. Just a year later, the platform skyrocketed to become the most downloaded app globally. In China, TikTok goes by Douyin, and it’s been a huge hit over there too.
        </p>
      </>
    ),
    img: pic_02,
    blurhash: '|FD8%p9t5W=|V@~BEMSi^PsmNHRj-UIps.oeE2xGoMIot6s:I:WBjZWVWVNHxZxYofNHoJs:WVofRks:s.WBogR*ofs.WVxaR*NHs-axt7WUayWCWVWWjZs.WWR*oKWBbHs.jZWXR*WVayays.ayNHfks.ofayj@ofWVj]',
    picName: 'pic_02',
  },
  {
    year: '2019',
    title: 'The First Content House',
    content: (
      <>
        <p>
          So, you might be wondering, "What’s this all about?" <br />
          Well, it’s a cool socio-economic idea where a bunch of popular TikTok creators live together in one house. The goal? To build a community where they can hang out, collaborate, and create content together.
        </p>
        <p>
          That’s where Hype House comes in — it was the first of its kind! Founded by TikTok stars like Chase Hudson, Alex Warren, and Daisy Keech, it turned into a go-to spot for shooting videos and became a home for content creators. After that, more places popped up, like Sway House and Clubhouse BH, adding even more flavor to the social media scene!
        </p>
      </>
    ),
    img: pic_03,
    blurhash: '|49GdRr;011Q03$d~VwIIVEgxZsoIpj@%1oeIpR+00XT^+vy^*%f9FNyoz=xIqIp%1%1RjNH%2jFlAwHn3yDD*9a-;WAjE%1NH%0xZ9aR.xaoHxtH?kXx]R5-oS$9G%L-o0gxaxZfhxuV@niX9Rj-;9aM{?aaxV@xuIpIW',
    picName: 'pic_03',
  },
  {
    year: '2020',
    title: "Charli D'Amelio",
    content: (
      <>
        <p>
          Content houses really turn creators into stars. Just look at Charli D’Amelio. She was part of Hype House and became the first person to hit 100 million subscribers on TikTok. Now, she’s a total icon, teaming up with big-name brands and being the face of some well-known companies. Even with all her fame, Charli still keeps it real by posting videos on TikTok. We can’t get enough of Charli D’Amelio!
        </p>
      </>
    ),
    img: pic_04,
    blurhash: '|48gENNe02%2xZVsD%x]Sg^kS4EL%2ofV@s:XSRk0MV?}oogE3f+-;NGRQ0LV@}?NHM|ozX8V?V@=sWBEQs:-US4IVROxt#7t7FLoJxYR+RjWAx]Ips:%LIpIp%2%1o#kDEkxa%0IoS5%1kCbvj]?Ht7IVRjxtRjIpoLs.',
    picName: 'pic_04',
  },
  {
    year: '2020',
    title: 'POV: The Term That Is a Must to Understand the Context',
    content: (
      <>
        <p>
          On TikTok, "POV" means "point of view," and it’s all about users acting out scenes or stories from a specific character's perspective. You’ll usually see the title "POV" at the start, followed by a little setup about what’s happening. This video style took off on TikTok back in 2020 and has been a go-to format for creators ever since!
        </p>
      </>
    ),
    img: pic_05,
    blurhash: '|48gENNe02%2xZVsD%x]Sg^kS4EL%2ofV@s:XSRk0MV?}oogE3f+-;NGRQ0LV@}?NHM|ozX8V?V@=sWBEQs:-US4IVROxt#7t7FLoJxYR+RjWAx]Ips:%LIpIp%2%1o#kDEkxa%0IoS5%1kCbvj]?Ht7IVRjxtRjIpoLs.',
    picName: 'pic_05',
  },
  {
    year: '2020',
    title: 'The Best of the Best: Bella Poarch and Khaby Lame',
    content: (
      <>
        <p>
          Not everyone who jumps on a platform becomes a star like those in content houses. Some people hit it big by simply being funny or rocking a unique look.
        </p>
        <p>
          Take Bella Poarch, for example. On August 18, 2020, she dropped a short video that’s still the most liked TikTok ever, with over 50.5 million likes and a jaw-dropping 1.5 billion views!
        </p>
        <p>
          That same year, Khaby Lame skyrocketed to fame as the fastest-growing creator on TikTok. His videos took off, racking up crazy view counts and striking a chord with users — who, let’s face it, can be pretty picky about what they watch.
        </p>
      </>
    ),
    img: pic_06,
    blurhash: '|48gENNe02%2xZVsD%x]Sg^kS4EL%2ofV@s:XSRk0MV?}oogE3f+-;NGRQ0LV@}?NHM|ozX8V?V@=sWBEQs:-US4IVROxt#7t7FLoJxYR+RjWAx]Ips:%LIpIp%2%1o#kDEkxa%0IoS5%1kCbvj]?Ht7IVRjxtRjIpoLs.',
    picName: 'pic_06',
  },
  {
    year: '2021',
    title: '#BookTok',
    content: (
      <>
        <p>
          Hashtags on TikTok are a big deal and aren’t just sticking to the app — they’re popping up in real life too. A great example is #BookTok, where users post book reviews, recommendations, and their thoughts on what they’ve read. It’s really taken off! Because of this buzz, many online and local bookstores are now using #BookTok to showcase the trending reads everyone’s raving about.
        </p>
      </>
    ),
    img: pic_07,
    blurhash: '|48gENNe02%2xZVsD%x]Sg^kS4EL%2ofV@s:XSRk0MV?}oogE3f+-;NGRQ0LV@}?NHM|ozX8V?V@=sWBEQs:-US4IVROxt#7t7FLoJxYR+RjWAx]Ips:%LIpIp%2%1o#kDEkxa%0IoS5%1kCbvj]?Ht7IVRjxtRjIpoLs.',
    picName: 'pic_07',
  },
  {
    year: '2022',
    title: 'For You Page or How TikTok is Becoming a Gen Z Subculture',
    content: (
      <>
        <p>
          Generation Z is all about TikTok, leaving Google, YouTube, and even Instagram in the dust. TikTok is where trends and stars come to life, and it’s become the go-to place for music to go global.
          But here’s the thing: Gen Z TikTokers don’t just scroll through videos — they create them! A whopping 83% of TikTok users have jumped in front of the camera to make their own content.
        </p>
        <p>
          Even though the number of TikTok users aged 20 to 25 is pretty much the same as those aged 25 to 30 now, we want to give a shout-out to Zoomers. They’re the ones who kicked off a whole new culture that millennials are loving and even boomers are starting to embrace!
        </p>
      </>
    ),
    img: pic_08,
    blurhash: '|48gENNe02%2xZVsD%x]Sg^kS4EL%2ofV@s:XSRk0MV?}oogE3f+-;NGRQ0LV@}?NHM|ozX8V?V@=sWBEQs:-US4IVROxt#7t7FLoJxYR+RjWAx]Ips:%LIpIp%2%1o#kDEkxa%0IoS5%1kCbvj]?Ht7IVRjxtRjIpoLs.',
    picName: 'pic_08',
  },
  {
    year: '2023',
    title: 'Ban Alert',
    content: (
      <>
        <p>
          What could possibly overshadow a platform that’s already racked up over 3.5 billion downloads?
        </p>
        <p>
          Well, it seems some American politicians think it’s a threat to national security. While a few activists are trying to get TikTok banned in their countries, others are diving in and connecting with its huge audience by becoming bloggers.
        </p>
        <p>
          Check out Minnesota Senate member Matt Little — he had a pretty fun reaction to the news about a potential ban. He recorded a video lip-syncing to DJ Khaled’s 2010 hit “All I Do Is Win.” It’s a perfect example of how this platform keeps sparking creativity, and it definitely deserves a spot in our museum’s exhibit!
        </p>
      </>
    ),
    img: pic_09,
    blurhash: '|48gENNe02%2xZVsD%x]Sg^kS4EL%2ofV@s:XSRk0MV?}oogE3f+-;NGRQ0LV@}?NHM|ozX8V?V@=sWBEQs:-US4IVROxt#7t7FLoJxYR+RjWAx]Ips:%LIpIp%2%1o#kDEkxa%0IoS5%1kCbvj]?Ht7IVRjxtRjIpoLs.',
    picName: 'pic_09',
  },
  {
    year: '2024',
    title: "TikTok's Album Party",
    content: (
      <>
        <p>
          TikTok has launched a new in-app experience to celebrate the launch of Sabrina Carpenter’s new album, which includes opportunities for expanded exposure in the app, as well as bonus features for those who complete various in-app tasks.
        </p>
      </>
    ),
    img: pic_10,
    blurhash: '|48gENNe02%2xZVsD%x]Sg^kS4EL%2ofV@s:XSRk0MV?}oogE3f+-;NGRQ0LV@}?NHM|ozX8V?V@=sWBEQs:-US4IVROxt#7t7FLoJxYR+RjWAx]Ips:%LIpIp%2%1o#kDEkxa%0IoS5%1kCbvj]?Ht7IVRjxtRjIpoLs.',
    picName: 'pic_10',
  },
];